import "./VideoCarousel.css";
import React from "react";
import { Carousel } from "react-bootstrap";
import Vid1 from "./videos/vid1.mp4";
import Vid2 from "./videos/vid2.mp4";
import Vid3 from "./videos/vid3.mp4";
import ReactPlayer from "react-player";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from 'react-router-dom';
import fitty from "fitty";

const VideoCarousel = () => {
  const videoProperties = [
    {
      id: 1,
      title: "Video 1",
      src: Vid1,
    },
    {
      id: 2,
      title: "Video 2",
      src: Vid2,
    },
    {
      id: 3,
      title: "Video 3",
      src: Vid3,
    }
  ];

  return (
    <div className="App" style={{ position: 'relative' }}>
      <Carousel className="carousel" >
        {videoProperties.map((videoObj) => {
          return (
            <Carousel.Item key={videoObj.id}>
              <ReactPlayer
                width={"100%"}
                height={"100%"}
                url={videoObj.src}
                pip={true}
                fade={true}
                controls={false}
                playing={true}
                autoPlay={true}
                loop={true}
                muted
                playsinline={true}
              />

            </Carousel.Item>
          );
        })}
      </Carousel>
      <div className="carouselText" style={{ position: 'absolute', top: '25%', paddingRight: '10%', paddingLeft: '10%' }}>
        <h3 className="fit">Signature Move</h3>
        <h3 className="fit">Investment Group</h3>
      </div>
      <div className="carouselText" style={{ position: 'absolute', top: '65%', paddingRight: '10%', paddingLeft: '10%', textAlign: 'center', maxHeight: '130px'}}>
        <p className="fit bottomText">Signature Move Investment Group is a property development firm specializing in luxury residential real estate. Founded in 2018, the vision of the company has always been to provide the highest quality homes in the market. All of our homes feature innovative architectural designs along with high end interior finishes, making them one-of-a-kind homes that any family will cherish for a lifetime.</p>
      </div>
      <Carousel.Caption>
        {/* <h3>{videoObj.title}</h3> */}
        <Link to="/request" className="btnStyle  ">Find Your Signature Move</Link>

        {/* <p>{videoObj.credit}</p> */}
      </Carousel.Caption>
    </div>
  );
};
fitty('.fit',{
  multiLine: true,
  minSize: 8
});
export default VideoCarousel;
